/* eslint-disable */

import axios from 'axios';

export const currentHref = window.location.href;
export const currentLocation = window.location.pathname;
export const currentPage = currentLocation.split('/')[1];
export const currentSubpage = currentLocation.split('/')[2];

export const apiUrl = 'https://webapi.porscheinterauto.com.pl';
export const apiUrlPiamarket = 'https://webapi.piamarket.pl';

export const lmsUrl = 'https://lms-api.activemotors.pl/send/';

/*
##################

    Promise based function that send request to server
		it caches the results,
		so if you would send 2 same request to API it will send just one

##################
*/

let promises = sessionStorage.getItem('promises')
	? {}
	: // JSON.parse(sessionStorage.getItem('promises'))
	  {};

// console.log(promises);

export function apiRequestPromise(api = apiUrl, method, methodParams = '') {
	const promiseKey = `${method}${methodParams}`;
	if (!promises[promiseKey]) {
		promises[promiseKey] = axios({
			url: `/api/api.php?${methodParams}`,
			params: {
				method,
				api,
			},
			headers: {
				csrftoken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			},
		}).then(data => {
			// const promisesStorage = Object.assign({}, promises);
			// console.log(data);
			// promisesStorage[method] =
			// sessionStorage.setItem('promises', );
			return data;
		});
	}
	// console.log(promises);
	return promises[promiseKey];
}

// apiRequestPromise(apiUrl, 'brands').then(response => {
// 	const data = response.data.brands;
//
// 	console.log(data);
// });

/*
##################

    Regular function that send request to server
		no matter what

##################
*/
export function apiRequest(api = apiUrl, method, methodParams = '') {
	return axios({
		url: `/api/api.php?${methodParams}`,
		params: {
			method,
			api,
		},
		headers: {
			csrftoken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
		},
	});
}

export function parseUrlParams(urlParams) {
	const joinByEquals = pair => pair.join('=');
	const params = Object.entries(urlParams)
		.map(joinByEquals)
		.join('&');
	if (params) {
		return `${params}`;
	} else {
		return '';
	}
}

export function getUrlParameter(sParam, sURL) {
	const sPageURL = !sURL
		? decodeURIComponent(window.location.search.substring(1))
		: decodeURIComponent(sURL.substring(1));

	const sURLVariables = sPageURL.split('&');

	let sParameterName;

	let i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
}

export function addVolkswagenTypeDealer(data) {
	const dataChanged = data.map(el => {
		// użytkowe, nie krańcowa, bo w nazwie już ma "użytkowe"
		if (el.brand_id == 235 && el.id != 5) {
			el.name += ' (Użytkowe)';
		}
		return el;
	});
	return dataChanged;
}

export function resetSelect(selects, startOptionText) {
	const itemLists = selects;

	[...itemLists].forEach(itemList => {
		const list = itemList;
		list.innerHTML = `<option value="">${startOptionText}</option>`;
	});
}

export function populateSelect({
	selects,
	apiMethod,
	methodParams = '',
	listKey,
	itemNameKey,
	itemValueKey,
	stringProcessor,
	api = apiUrl,
	additionalDataToExtract = [],
	startOptionText = 'Wybierz',
	resetOnEmpty = false,
	selectedOptionValue = '',
}) {
	function getSelectTemplate(item) {
		let template;

		function transformString(value, processFn = stringProcessor) {
			if (processFn) {
				return processFn(value);
			}

			return value;
		}

		const selected = selectedOptionValue == item[itemValueKey] ? 'selected' : '';

		if (itemNameKey && itemValueKey) {
			template = `<option ${selected}
      ${additionalDataToExtract.map(v => `data-${v}="${item[v]}"`)}
      value="${transformString(item[itemValueKey])}">${item[itemNameKey]}</option>`;
		} else if (itemNameKey) {
			template = `<option ${selected}>${item[itemNameKey]}</option>`;
		} else {
			template = `<option ${selected}>${item}</option>`;
		}

		return template;
	}

	const itemLists = selects;

	if (selects) {
		apiRequestPromise(api, apiMethod, methodParams)
			.then(response => {
				let dataItems = response.data[listKey];

				if (apiMethod == 'dealers') {
					dataItems = addVolkswagenTypeDealer(dataItems);
				}
				[...itemLists].forEach(itemList => {
					const list = itemList;
					list.innerHTML = `<option value="">${startOptionText}</option>`;
					list.innerHTML += dataItems.map(dataItem => getSelectTemplate(dataItem)).join(',');
				});
			})
			.catch(error => console.log(error));
	}
}

export function setParam(key, value) {
	key = encodeURIComponent(key);
	value = encodeURIComponent(value);

	let s = document.location.search;
	const kvp = `${key}=${value}`;

	const r = new RegExp(`(&|\\?)${key}=[^&]*`);

	s = s.replace(r, `$1${kvp}`);

	if (!RegExp.$1) {
		s += (s.length > 0 ? '&' : '?') + kvp;
	}

	// again, do what you will here
	window.history.replaceState('', '', `${s}${window.location.hash}`);
}

export function removeParams() {
	window.history.replaceState('', '', `${s}${window.location.hash}`);
}

export function filterData(data, filters, listKey) {
	const useConditions = filter => item =>
		Object.keys(filter).every(
			k =>
				item[k] == filter[k] ||
				(Array.isArray(filter[k]) && filter[k].includes(item[k])) ||
				(typeof filter[k] === 'object' && +filter[k].min <= item[k] && item[k] <= +filter[k].max) ||
				(typeof filter[k] === 'function' && filter[k](item[k]))
		);

	const dataChanged = Object.assign({}, data);
	const filteredOffers = data[listKey].filter(useConditions(filters));
	dataChanged[listKey] = filteredOffers;
	return dataChanged;
}

export function setFilters(filters, select) {
	console.log(filters);
	if (filters.hasOwnProperty(select.name) && select.value === '') {
		delete filters[select.name];
	} else {
		if (select.value != '') {
			filters[select.name] = select.value;
		}
	}
}

export function renderTemplate(data, container, appTemplate) {
	const dataTemplate = data;
	const containerTemplate = container;

	const html = appTemplate(dataTemplate);
	containerTemplate.innerHTML = html;
}

export function slug(s, opt) {
	s = String(s);
	opt = Object(opt);

	const defaults = {
		delimiter: '-',
		limit: undefined,
		lowercase: true,
		replacements: {},
		transliterate: typeof XRegExp === 'undefined',
	};

	// Merge options
	for (var k in defaults) {
		if (!opt.hasOwnProperty(k)) {
			opt[k] = defaults[k];
		}
	}

	const char_map = {
		// Latin
		À: 'A',
		Á: 'A',
		Â: 'A',
		Ã: 'A',
		Ä: 'A',
		Å: 'A',
		Æ: 'AE',
		Ç: 'C',
		È: 'E',
		É: 'E',
		Ê: 'E',
		Ë: 'E',
		Ì: 'I',
		Í: 'I',
		Î: 'I',
		Ï: 'I',
		Ð: 'D',
		Ñ: 'N',
		Ò: 'O',
		Ó: 'O',
		Ô: 'O',
		Õ: 'O',
		Ö: 'O',
		Ő: 'O',
		Ø: 'O',
		Ù: 'U',
		Ú: 'U',
		Û: 'U',
		Ü: 'U',
		Ű: 'U',
		Ý: 'Y',
		Þ: 'TH',
		ß: 'ss',
		à: 'a',
		á: 'a',
		â: 'a',
		ã: 'a',
		ä: 'a',
		å: 'a',
		æ: 'ae',
		ç: 'c',
		è: 'e',
		é: 'e',
		ê: 'e',
		ë: 'e',
		ì: 'i',
		í: 'i',
		î: 'i',
		ï: 'i',
		ð: 'd',
		ñ: 'n',
		ò: 'o',
		ó: 'o',
		ô: 'o',
		õ: 'o',
		ö: 'o',
		ő: 'o',
		ø: 'o',
		ù: 'u',
		ú: 'u',
		û: 'u',
		ü: 'u',
		ű: 'u',
		ý: 'y',
		þ: 'th',
		ÿ: 'y',

		// Latin symbols
		'©': '(c)',

		// Greek
		Α: 'A',
		Β: 'B',
		Γ: 'G',
		Δ: 'D',
		Ε: 'E',
		Ζ: 'Z',
		Η: 'H',
		Θ: '8',
		Ι: 'I',
		Κ: 'K',
		Λ: 'L',
		Μ: 'M',
		Ν: 'N',
		Ξ: '3',
		Ο: 'O',
		Π: 'P',
		Ρ: 'R',
		Σ: 'S',
		Τ: 'T',
		Υ: 'Y',
		Φ: 'F',
		Χ: 'X',
		Ψ: 'PS',
		Ω: 'W',
		Ά: 'A',
		Έ: 'E',
		Ί: 'I',
		Ό: 'O',
		Ύ: 'Y',
		Ή: 'H',
		Ώ: 'W',
		Ϊ: 'I',
		Ϋ: 'Y',
		α: 'a',
		β: 'b',
		γ: 'g',
		δ: 'd',
		ε: 'e',
		ζ: 'z',
		η: 'h',
		θ: '8',
		ι: 'i',
		κ: 'k',
		λ: 'l',
		μ: 'm',
		ν: 'n',
		ξ: '3',
		ο: 'o',
		π: 'p',
		ρ: 'r',
		σ: 's',
		τ: 't',
		υ: 'y',
		φ: 'f',
		χ: 'x',
		ψ: 'ps',
		ω: 'w',
		ά: 'a',
		έ: 'e',
		ί: 'i',
		ό: 'o',
		ύ: 'y',
		ή: 'h',
		ώ: 'w',
		ς: 's',
		ϊ: 'i',
		ΰ: 'y',
		ϋ: 'y',
		ΐ: 'i',

		// Turkish
		Ş: 'S',
		İ: 'I',
		Ç: 'C',
		Ü: 'U',
		Ö: 'O',
		Ğ: 'G',
		ş: 's',
		ı: 'i',
		ç: 'c',
		ü: 'u',
		ö: 'o',
		ğ: 'g',

		// Russian
		А: 'A',
		Б: 'B',
		В: 'V',
		Г: 'G',
		Д: 'D',
		Е: 'E',
		Ё: 'Yo',
		Ж: 'Zh',
		З: 'Z',
		И: 'I',
		Й: 'J',
		К: 'K',
		Л: 'L',
		М: 'M',
		Н: 'N',
		О: 'O',
		П: 'P',
		Р: 'R',
		С: 'S',
		Т: 'T',
		У: 'U',
		Ф: 'F',
		Х: 'H',
		Ц: 'C',
		Ч: 'Ch',
		Ш: 'Sh',
		Щ: 'Sh',
		Ъ: '',
		Ы: 'Y',
		Ь: '',
		Э: 'E',
		Ю: 'Yu',
		Я: 'Ya',
		а: 'a',
		б: 'b',
		в: 'v',
		г: 'g',
		д: 'd',
		е: 'e',
		ё: 'yo',
		ж: 'zh',
		з: 'z',
		и: 'i',
		й: 'j',
		к: 'k',
		л: 'l',
		м: 'm',
		н: 'n',
		о: 'o',
		п: 'p',
		р: 'r',
		с: 's',
		т: 't',
		у: 'u',
		ф: 'f',
		х: 'h',
		ц: 'c',
		ч: 'ch',
		ш: 'sh',
		щ: 'sh',
		ъ: '',
		ы: 'y',
		ь: '',
		э: 'e',
		ю: 'yu',
		я: 'ya',

		// Ukrainian
		Є: 'Ye',
		І: 'I',
		Ї: 'Yi',
		Ґ: 'G',
		є: 'ye',
		і: 'i',
		ї: 'yi',
		ґ: 'g',

		// Czech
		Č: 'C',
		Ď: 'D',
		Ě: 'E',
		Ň: 'N',
		Ř: 'R',
		Š: 'S',
		Ť: 'T',
		Ů: 'U',
		Ž: 'Z',
		č: 'c',
		ď: 'd',
		ě: 'e',
		ň: 'n',
		ř: 'r',
		š: 's',
		ť: 't',
		ů: 'u',
		ž: 'z',

		// Polish
		Ą: 'A',
		Ć: 'C',
		Ę: 'e',
		Ł: 'L',
		Ń: 'N',
		Ó: 'o',
		Ś: 'S',
		Ź: 'Z',
		Ż: 'Z',
		ą: 'a',
		ć: 'c',
		ę: 'e',
		ł: 'l',
		ń: 'n',
		ó: 'o',
		ś: 's',
		ź: 'z',
		ż: 'z',

		// Latvian
		Ā: 'A',
		Č: 'C',
		Ē: 'E',
		Ģ: 'G',
		Ī: 'i',
		Ķ: 'k',
		Ļ: 'L',
		Ņ: 'N',
		Š: 'S',
		Ū: 'u',
		Ž: 'Z',
		ā: 'a',
		č: 'c',
		ē: 'e',
		ģ: 'g',
		ī: 'i',
		ķ: 'k',
		ļ: 'l',
		ņ: 'n',
		š: 's',
		ū: 'u',
		ž: 'z',
	};

	// Make custom replacements
	for (var k in opt.replacements) {
		s = s.replace(RegExp(k, 'g'), opt.replacements[k]);
	}

	// Transliterate characters to ASCII
	if (opt.transliterate) {
		for (var k in char_map) {
			s = s.replace(RegExp(k, 'g'), char_map[k]);
		}
	}

	// Replace non-alphanumeric characters with our delimiter
	const alnum =
		typeof XRegExp === 'undefined' ? RegExp('[^a-z0-9]+', 'ig') : XRegExp('[^\\p{L}\\p{N}]+', 'ig');
	s = s.replace(alnum, opt.delimiter);

	// Remove duplicate delimiters
	s = s.replace(RegExp(`[${opt.delimiter}]{2,}`, 'g'), opt.delimiter);

	// Truncate slug to max. characters
	s = s.substring(0, opt.limit);

	// Remove delimiter from ends
	s = s.replace(RegExp(`(^${opt.delimiter}|${opt.delimiter}$)`, 'g'), '');

	return opt.lowercase ? s.toLowerCase() : s;
}
